import React from 'react';

import { TableRow } from '@unimed-fesp/components';
import { CustomTableHeader } from './styles';

const TableHistoricoHeader = ({ headers }) => {
  return (
    <TableRow>
      {headers.map((header) => (
        <CustomTableHeader
          key={header.id}
          maxWidth={header.width}
          minWidth={header.minWidth}
        >
          {header.title}
        </CustomTableHeader>
      ))}
    </TableRow>
  );
};

export default TableHistoricoHeader;
